let cacheProvider = null;

export function createCache(cacheData) {
  if (
    !cacheProvider
    && cacheData instanceof Map
  ) {
    cacheProvider = cacheData;
  }
}

export function getCacheProvider() {
  return cacheProvider;
}
